import IconOption from "@/components/TableOptions/IconOption"
import type {
  FreeMaterialCourse,
  FreeMaterialSubject,
} from "@/types/freeMaterialsTypes"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { BiHome } from "react-icons/bi"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"

export default function FreeMaterialDetailsSideBar({
  course,
}: {
  course: FreeMaterialCourse
}) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="bg-light w-25 p-2">
      <div className="mb-3">
        <IconOption
          tooltip={t("buttons.back")}
          icon={<BiHome size={22} />}
          onClick={() => navigate("/free-materials")}
        />
      </div>
      <div className="overflow-y-auto">
        <NestedContent data={course?.subjects} />
      </div>
    </div>
  )
}

function NestedContent({ data }: { data?: Array<FreeMaterialSubject> }) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  if (!data || !data?.length) return null

  return (
    <Accordion>
      {data?.map((subject) => (
        <AccordionItem key={subject?.id} eventKey={String(subject?.id)}>
          <AccordionHeader className="d-flex justify-content-between">
            <p className="fs-5 fw-semibold text-capitalize">{subject.name}</p>
          </AccordionHeader>
          <AccordionBody className="px-1 py-2 ps-3">
            <ListGroup className="p-0">
              {subject?.free_materials?.map((material) => (
                <ListGroupItem
                  action
                  key={material.id}
                  eventKey={String(material.id)}
                  as="div"
                  onClick={() => {
                    const isPaidMaterial = !material?.link
                    if (isPaidMaterial) {
                      toast.info(t("freeMaterialsPage.paidMaterialToast"))
                    } else {
                      navigate(
                        `/free-materials/${subject?.free_material_course_id}/details/${subject?.id}/${material?.id}`
                      )
                    }
                  }}
                >
                  {material.title}
                </ListGroupItem>
              ))}
            </ListGroup>
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
